import { ArrowRightIcon } from '@heroicons/react/20/solid';
import _ from 'lodash';
import { useRouter } from 'next/router';
import useSWR from 'swr';

import Footer from 'components/Footer';
import MaxWidthContainer from 'components/MaxWidthContainer';
import Menubar from 'components/Menubar';

import { swrFetcher } from 'utils/api';

import { useAppLaunch } from 'contexts/AppLaunch';

import Breadcrumbs from 'components/Breadcrumbs';
import StrapiImg from 'components/StrapiImg';
import useRWD from 'hooks/useRWD';

export default function Save() {
  const router = useRouter();
  const { isLoading: isAppLaunchLoading, notifications } = useAppLaunch();
  // const { user, getAuthorizationHeader } = useUserAuth();
  const { isLg } = useRWD();

  const {
    data: contents,
    isLoading: isContentsLoading,
    mutate: mutateContents,
  } = useSWR(
    '/api/v3/member/contents',
    (url) => swrFetcher(url)
    // { fallbackData: [] }
  );

  const breadcrumbs = [
    { name: '首頁', href: '/' },
    { name: '會員專屬內容', href: null },
  ];

  const isLoading = isAppLaunchLoading || isContentsLoading;

  return (
    <div>
      <Menubar
        props={{
          homeExtend: false,
          sourceUI: 'Profile',
        }}
      />
      <div
        className={
          'globals-centerContentsMargin relative' +
          (notifications && notifications.length > 0 ? ' withNoti' : '')
        }
      >
        <MaxWidthContainer className="px-4 lg:px-0">
          <div className="pb-3.5 pt-[22px] lg:pb-10 lg:pt-10">
            <Breadcrumbs breadcrumbs={breadcrumbs} />
          </div>
          <div className="flex flex-row gap-x-6 pb-30">
            {isLoading ? (
              <div className="flex h-[800px] w-full items-center justify-center gap-x-4">
                <img
                  className="h-[100px] w-[100px]"
                  src="/images/search-placeholder.gif"
                ></img>
              </div>
            ) : (
              <div className="min-w-0 grow lg:block">
                <p className="block pb-3.5 text-xl font-bold lg:hidden">
                  會員專屬內容
                </p>
                {contents && contents.length === 0 && (
                  <div className="flex flex-col items-center justify-center pt-30 lg:pt-40">
                    <img
                      src="/images/icons/sorra-empty.png"
                      className="h-32 w-32 object-contain lg:h-40 lg:w-40"
                    />
                    <p className="text-center text-lg font-medium">暫無記錄</p>
                  </div>
                )}
                <div className="flex flex-col gap-y-5 lg:gap-y-9">
                  {contents &&
                    contents.map((content, idx, arr) => {
                      const {
                        id,
                        title,
                        description,
                        thumbnail,
                        mobile_thumbnail,
                        url,
                      } = content;
                      const thumbnailUrl = _.get(thumbnail, 'url');
                      const mobileThumbnailUrl = _.get(mobile_thumbnail, 'url');
                      const imageUrl = isLg
                        ? thumbnailUrl
                        : mobileThumbnailUrl
                          ? mobileThumbnailUrl
                          : thumbnailUrl;
                      return (
                        <div
                          key={id}
                          className="flex flex-col items-start gap-x-10 gap-y-5 lg:flex-row"
                        >
                          <div
                            className="aspect-[343/193] w-full shrink-0 cursor-pointer overflow-hidden rounded-lg lg:w-[343px]"
                            onClick={() => {
                              window.open(url, '_blank');
                            }}
                          >
                            <StrapiImg
                              src={imageUrl}
                              className="h-full w-full object-cover"
                            />
                          </div>
                          <div className="flex w-full min-w-0 flex-col border-b-0 border-gray-200 pb-0 pt-0 lg:w-auto lg:grow lg:border-b lg:pb-15 lg:pt-8">
                            <p className="w-full text-2xl font-bold text-gray-900">
                              {title}
                            </p>
                            <p className="whitespace-pre-line pt-4 text-base text-gray-500">
                              {description}
                            </p>
                            <div
                              className="flex cursor-pointer flex-row items-center gap-x-1.5 pt-4 text-sorra-pink"
                              onClick={() => {
                                window.open(url, '_blank');
                              }}
                            >
                              <p className="text-base font-semibold">
                                立即閱讀
                              </p>
                              <div className="">
                                <ArrowRightIcon className="h-4 w-4" />
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            )}
          </div>
        </MaxWidthContainer>
      </div>

      <Footer />
    </div>
  );
}
